export default __webpack_public_path__ + "static/media/token.5ab35795.svg";